module.exports = __webpack_public_path__ + "img/342.6b31d354.png";